export function getUrlIncluding(
  allUrls: string[],
  paths: string[],
  excludePaths?: string[]
): string | null {
  const url = allUrls.find(url => {
    return (
      paths.every(path => url.includes(path)) &&
      (!excludePaths || excludePaths.every(path => !url.includes(path)))
    );
  });
  if (url) {
    const parts = url.split("||");
    const extracted = parts.length > 1 ? parts[1]?.trim() : undefined;
    return extracted || null;
  }
  return null;
}

export function removeEndingStartingWith(
  url: string | null,
  startingString: string
): string {
  if (!url) return "";
  const index = url.indexOf(startingString);
  if (index !== -1) {
    return url.substring(0, index);
  }
  return url;
}

export function hasPermission(
  userPermissions: string[] | Record<string, boolean> | null | undefined,
  requiredPermission: string
): boolean;
export function hasPermission(
  permissionsObj:
    | {
        userPermissions?: string[];
        accountPermissions?: string[];
      }
    | null
    | undefined,
  requiredPermission: {
    permission: string;
    scope: "userPermissions" | "accountPermissions" | "any";
  }
): boolean;
export function hasPermission(
  permissionsInput:
    | string[]
    | Record<string, boolean>
    | { userPermissions?: string[]; accountPermissions?: string[] }
    | null
    | undefined,
  requiredPermission:
    | string
    | {
        permission: string;
        scope: "userPermissions" | "accountPermissions" | "any";
      }
): boolean {
  // Handle legacy string permission format
  if (typeof requiredPermission === "string") {
    const userPermissions = permissionsInput as
      | string[]
      | Record<string, boolean>
      | null
      | undefined;
    if (!userPermissions) return false;
    if (Array.isArray(userPermissions)) {
      return userPermissions.some(
        p => p === requiredPermission || p.startsWith(`${requiredPermission}.`)
      );
    }
    return Boolean(userPermissions[requiredPermission]);
  }

  // Handle new object permission format
  const permissionsObj = permissionsInput as
    | { userPermissions?: string[]; accountPermissions?: string[] }
    | null
    | undefined;
  if (!permissionsObj) return false;

  const checkPermission = (permissions: string[] | undefined): boolean => {
    if (!permissions) return false;
    return permissions.some(
      p =>
        p === requiredPermission.permission ||
        p.startsWith(`${requiredPermission.permission}.`)
    );
  };

  switch (requiredPermission.scope) {
    case "userPermissions":
      return checkPermission(permissionsObj.userPermissions);
    case "accountPermissions":
      return checkPermission(permissionsObj.accountPermissions);
    case "any":
      return (
        checkPermission(permissionsObj.userPermissions) ||
        checkPermission(permissionsObj.accountPermissions)
      );
    default: {
      const _exhaustiveCheck: never = requiredPermission.scope;
      return false;
    }
  }
}
